module.exports = __webpack_public_path__ + "static/media/29.ff38f2e8.JPG";